import { createElement, isValidElement } from 'react';
import clsx from 'clsx';
import styles from './Button.module.css';

/**
 * Botão base do Movez. Variantes:
 *  - primary : gradiente do tema (CTA) — texto var(--ink)
 *  - outline : borda var(--volt)
 *  - ghost   : transparente
 *  - danger  : var(--danger)
 */
export default function Button({
  variant = 'primary',
  size = 'md',
  loading = false,
  disabled = false,
  icon,
  iconRight,
  fullWidth = false,
  type = 'button',
  className,
  children,
  ...props
}) {
  const renderIcon = (ic) =>
    ic && (isValidElement(ic) ? ic : createElement(ic, { size: 18, 'aria-hidden': true }));

  return (
    <button
      type={type}
      className={clsx(
        styles.button,
        styles[variant],
        styles[size],
        fullWidth && styles.fullWidth,
        loading && styles.loading,
        className
      )}
      disabled={disabled || loading}
      {...props}
    >
      {loading && <span className={styles.spinner} aria-hidden />}
      {!loading && icon && <span className={styles.icon}>{renderIcon(icon)}</span>}
      {children && <span>{children}</span>}
      {!loading && iconRight && <span className={styles.icon}>{renderIcon(iconRight)}</span>}
    </button>
  );
}
